import type { IAppUserState } from "./reducer";
import userActionTypes from "./types";

export const updateAppUserState = (payload: Partial<IAppUserState>) => ({
  type: userActionTypes.UPDATE_APP_USER_STATE,
  payload,
});

export const logoutUserAction = () => ({
  type: userActionTypes.LOGOUT,
  payload: {},
});
